module.exports = __webpack_public_path__ + "static/media/alfa_2.75a1f606.mp4";